import { useEffect, useState } from 'react';

export function useWindowDimensions(enabled = true) {
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    if (!enabled) return;
    const handleResize = () => {
      setWindowDimensions((current) => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        if (current.width === width && current.height === height)
          return current;
        return { width, height };
      });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [enabled]);

  return windowDimensions;
}
